// extracted by mini-css-extract-plugin
export default {"actionsView":"styles_actionsView__zBbWC","singleAction":"styles_singleAction__EWEg+","ui-spin":"styles_ui-spin__6sA-r"};